import { Model } from "@vuex-orm/core";

export default class BizReviewSettings extends Model {
  static entity = "bizReviewSettings";

  static fields() {
    return {
      id: this.attr(),
      // accountId: this.attr(),
      isDirty: this.boolean(false),
      activeReviewTypes: this.attr(),
      // googlePlaceId: this.attr(),
      // facebookPageId: this.attr(),
      // yelpPageId: this.attr(),
      config: this.attr(),
      createdAt: this.attr(),
      updatedAt: this.attr()
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
